import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRightIcon } from 'lucide-react';
import { supplyGroups } from '../../data/home';
import { SectionTag } from '../shared/SectionTag';
export function SupplyList() {
  return <section className="bg-ink py-20 md:py-32" aria-labelledby="supply-heading" data-id="element-79" data-mp="dv162vj4m7b">
      <div className="mx-auto max-w-[1320px] px-5 md:px-8" data-id="element-80" data-mp="4ewszyn49vz9">
        <div className="mx-auto max-w-3xl text-center" data-id="element-81" data-mp="3mlkxpne98h4e">
          <SectionTag data-id="element-82" data-mp="3mk01zug7es4y">What we supply</SectionTag>
          <h2 id="supply-heading" className="mt-5 font-display text-[44px] font-bold uppercase leading-[0.9] text-chalk sm:text-5xl md:text-7xl" data-id="element-83" data-mp="3rkebzi1d8c5m">
            The Rest of Your Packaging Line
          </h2>
          <p className="mt-6 text-lg leading-relaxed text-muted" data-id="element-84" data-mp="3hn9lx74efwjj">
            Beyond what we make, we source the materials packers and converters order alongside it, so you deal
            with one supplier.
          </p>
        </div>

        <ul className="mt-16 grid gap-6 sm:grid-cols-2 lg:grid-cols-3" data-id="element-85" data-mp="1fssgpvs37d23">
          {supplyGroups.map(group => <li key={group.name} data-id="element-86" data-mp="2qctsqx32yuzj">
              <Link to="/products" className="group flex h-full flex-col overflow-hidden rounded-[28px] bg-flame" data-id="element-87" data-mp="2qbin0rq2rd5s">
                <div className="relative overflow-hidden" data-id="element-88" data-mp="302n5i1eylg5d">
                  <img src={group.image} alt={`${group.name} supplied by Universal Packaging Industries, Umm Al Quwain`} loading="lazy" className="aspect-[4/3] w-full object-cover transition-transform duration-300 ease-out-strong group-hover:scale-[1.04]" data-id="element-89" data-mp="30358ri01gums" />
                  <svg className="absolute -bottom-px left-0 h-12 w-full" viewBox="0 0 400 48" preserveAspectRatio="none" aria-hidden="true" data-id="element-90" data-mp="2hbm83hthlsnx">
                    <path d="M0 48 L0 30 C 120 -6, 250 52, 400 6 L400 48 Z" fill="#FF6A13" data-id="element-91" data-mp="3sqrcqrd6i1a6" />
                  </svg>
                </div>
                <div className="flex flex-1 flex-col px-7 pb-7 pt-2 text-center text-ink sm:text-left" data-id="element-92" data-mp="8no2j2db1ufd">
                  <h3 className="font-display text-[32px] font-bold uppercase leading-none" data-id="element-93" data-mp="dnahbg8s7iqa">{group.name}</h3>
                  <p className="mt-3 font-medium text-ink/80" data-id="element-94" data-mp="imncco9t3w3y">{group.items.join(' · ')}</p>
                  <span className="mt-auto flex items-center justify-center gap-3 pt-6 text-sm font-bold uppercase tracking-[0.06em] sm:justify-between" data-id="element-95" data-mp="3h3zkqtd2icbq">
                    View products
                    <span className="flex h-10 w-10 items-center justify-center rounded-full bg-ink text-flame transition-transform duration-150 ease-out-strong group-hover:rotate-45" data-id="element-96" data-mp="3r1x8lfr0m73t">
                      <ArrowUpRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-97" data-mp="3vugquq0ndqey" />
                    </span>
                  </span>
                </div>
              </Link>
            </li>)}
        </ul>

        <div className="mt-12 text-center" data-id="element-98" data-mp="1kgyh5d78f0vw">
          <Link to="/products" className="border-b-2 border-flame pb-1 text-sm font-bold uppercase tracking-[0.12em] text-chalk transition-colors duration-150 hover:text-flame" data-id="element-99" data-mp="1kfx7nd5v6mga">
            View All Products
          </Link>
        </div>
      </div>
    </section>;
}